import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ng-select',
  template: `
    <select
      class="ng-select"
      [disabled]="disabled"
      [ngModel]="value"
      (ngModelChange)="onSelect($event)"
    >
      <option *ngIf="placeholder" [ngValue]="null">{{ placeholder }}</option>
      <option *ngFor="let item of items" [ngValue]="getValue(item)">
        {{ getLabel(item) }}
      </option>
    </select>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgSelectComponent),
      multi: true,
    },
  ],
})
export class NgSelectComponent implements ControlValueAccessor {
  @Input() items: unknown[] = [];
  @Input() bindLabel?: string;
  @Input() bindValue?: string;
  @Input() placeholder?: string;
  @Input() virtualScroll?: boolean;

  @Output() change = new EventEmitter<unknown>();
  @Output() scrollToEnd = new EventEmitter<void>();

  value: unknown = null;
  disabled = false;

  private onChange: (value: unknown) => void = () => { };
  private onTouched: () => void = () => { };

  writeValue(value: unknown): void {
    this.value = value;
  }

  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(value: unknown): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
    this.change.emit(value);
  }

  getLabel(item: unknown): string {
    if (!item) {
      return '';
    }
    if (this.bindLabel && typeof item === 'object') {
      const label = (item as Record<string, unknown>)[this.bindLabel];
      return label !== undefined && label !== null ? String(label) : '';
    }
    return String(item);
  }

  getValue(item: unknown): unknown {
    if (!item) {
      return item;
    }
    if (this.bindValue && typeof item === 'object') {
      return (item as Record<string, unknown>)[this.bindValue];
    }
    return item;
  }
}
